/* ==========================================================
   MR CART DRAWER v3 — All Issues Fixed
   Fix 1: Gift milestone 10-15px before end
   Fix 2: Progress bar RED forced via style tag injection
   Fix 3: Free gift auto-add — string variantId fix
   Fix 4: Confetti wider spread bottom-right
   Fix 5: Dawn cart button hijacked — open mrCart instead
   Fix 6: Overlay click closes drawer
   Fix 7: Discount above subtotal (DOM order)
   ========================================================== */
(function () {
  'use strict';

  /* ===== DEFAULT CONFIG ===== */
  var CFG = {
    currency: 'PKR',
    milestones: [
      { id: 'shipping', label: 'Free Shipping!', threshold: 2990, icon: 'ship', enabled: true },
      { id: 'gift',     label: 'Free Gift!',     threshold: 4999, icon: 'gift', enabled: true },
      { id: 'luxury',   label: 'Free Luxury Box!', threshold: 6900, icon: 'box', enabled: false }
    ],
    freeGiftVariantId: '',
    socialProofEnabled: false,
    socialProofData: [
      { city: 'Karachi',   name: 'Mano',    product: 'Miss Rose BB Cream',    mins: 13 },
      { city: 'Lahore',    name: 'Tayyaba', product: 'Miss Rose Lipstick',    mins: 2  },
      { city: 'Islamabad', name: 'Sara',    product: 'Miss Rose Foundation',  mins: 7  },
      { city: 'Peshawar',  name: 'Hina',    product: 'Miss Rose Compact',     mins: 19 }
    ]
  };

  if (window.mrCartConfig) {
    var wc = window.mrCartConfig;
    if (wc.currency)          CFG.currency = wc.currency;
    if (wc.milestones)        CFG.milestones = wc.milestones;
    if (wc.freeGiftVariantId) CFG.freeGiftVariantId = String(wc.freeGiftVariantId);
    if (typeof wc.socialProofEnabled === 'boolean') CFG.socialProofEnabled = wc.socialProofEnabled;
    if (wc.socialProofData)   CFG.socialProofData = wc.socialProofData;
  }

  /* ===== STATE ===== */
  var cart = null;
  var isOpen = false;
  var milestonesFired = {};
  var prevTotalCents = 0;
  var giftBusy = false;
  var spIndex = 0;

  /* ===== ICONS ===== */
  var IC = {
    ship:  '<svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.2"><path stroke-linecap="round" stroke-linejoin="round" d="M9 17a2 2 0 11-4 0 2 2 0 014 0zM19 17a2 2 0 11-4 0 2 2 0 014 0z"/><path stroke-linecap="round" stroke-linejoin="round" d="M13 16V6a1 1 0 00-1-1H4a1 1 0 00-1 1v10l1.6 1.6A1 1 0 005 18h14a1 1 0 00.7-1.7L19 16zm0 0V9a1 1 0 011-1h2l3 5-1 2H13z"/></svg>',
    gift:  '<svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.2"><path stroke-linecap="round" stroke-linejoin="round" d="M12 8v13m0-13V6a4 4 0 00-8 0v2M4 8h16v2a4 4 0 01-4 4H8a4 4 0 01-4-4V8z"/></svg>',
    box:   '<svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.2"><path stroke-linecap="round" stroke-linejoin="round" d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"/></svg>',
    close: '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5"><path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12"/></svg>',
    cart:  '<svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" fill="none" viewBox="0 0 24 24" stroke="#ddd" stroke-width="1.3"><path stroke-linecap="round" stroke-linejoin="round" d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2 9m5-9v9m4-9v9m5-9l2 9"/></svg>',
    trash: '<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/></svg>'
  };

  /* ===== FIX 2: Inject style tag to force red — beats specificity wars ===== */
  function injectForceStyles() {
    var s = document.createElement('style');
    s.id = 'mr-force-styles';
    s.textContent = [
      '#mr-progress-fill {',
      '  background: #e74c3c !important;',
      '  background-color: #e74c3c !important;',
      '  height: 10px !important;',
      '  border-radius: 99px !important;',
      '  display: block !important;',
      '  position: relative !important;',
      '  z-index: 1 !important;',
      '}',
      '#mr-progress-track {',
      '  background: #e0e0e0 !important;',
      '  height: 10px !important;',
      '  border-radius: 99px !important;',
      '}'
    ].join('\n');
    document.head.appendChild(s);
  }

  /* ===== BUILD DOM ===== */
  function buildDOM() {
    injectForceStyles();

    /* Confetti canvas */
    var cv = document.createElement('canvas');
    cv.id = 'mr-confetti-canvas';
    document.body.appendChild(cv);

    /* Overlay */
    var ov = document.createElement('div');
    ov.id = 'mr-overlay';
    document.body.appendChild(ov);

    /* Social proof */
    var sp = document.createElement('div');
    sp.id = 'mr-social-proof';
    sp.innerHTML =
      '<button class="mr-sp-close" id="mr-sp-close">&#x2715;</button>' +
      '<img class="mr-sp-img" id="mr-sp-img" src="" alt="" />' +
      '<div class="mr-sp-text">' +
        '<div class="mr-sp-name" id="mr-sp-name"></div>' +
        '<div class="mr-sp-product" id="mr-sp-product"></div>' +
        '<div class="mr-sp-time" id="mr-sp-time"></div>' +
      '</div>';
    document.body.appendChild(sp);

    /* Drawer */
    var dr = document.createElement('div');
    dr.id = 'mr-drawer';
    dr.setAttribute('role', 'dialog');
    dr.setAttribute('aria-modal', 'true');
    dr.innerHTML =
      '<div id="mr-header">' +
        '<h2>Cart</h2>' +
        '<button id="mr-close-btn">' + IC.close + ' Close</button>' +
      '</div>' +
      '<div id="mr-progress-section">' +
        '<div id="mr-progress-msg"></div>' +
        '<div id="mr-progress-track">' +
          '<div id="mr-progress-fill" style="width:0%"></div>' +
          buildMilestonesHTML() +
        '</div>' +
      '</div>' +
      /* Scrollable body — items only */
      '<div id="mr-body">' +
        '<div id="mr-empty">' + IC.cart + '<p>Your cart is empty</p></div>' +
        '<div id="mr-items-wrap"></div>' +
      '</div>' +
      /* Fixed bottom panel — always visible at bottom */
      '<div id="mr-bottom">' +
        '<div id="mr-discount-section">' +
          '<div id="mr-discount-row">' +
            '<input id="mr-discount-input" type="text" placeholder="Apply Discount Code" autocomplete="off" />' +
            '<button id="mr-apply-btn">Apply</button>' +
          '</div>' +
          '<div id="mr-discount-msg"></div>' +
        '</div>' +
        '<div id="mr-totals">' +
          '<div class="mr-total-row"><span>Subtotal</span><span id="mr-subtotal-val"></span></div>' +
          '<div class="mr-total-row" id="mr-row-shipping" style="display:none"><span>Shipping</span><span class="mr-green">Free</span></div>' +
          '<div class="mr-total-row" id="mr-row-discount" style="display:none"><span>Discount</span><span id="mr-discount-val" class="mr-red"></span></div>' +
          '<div class="mr-total-row mr-total-final"><span>Total</span><span id="mr-total-val"></span></div>' +
        '</div>' +
        '<div id="mr-footer">' +
          '<button id="mr-checkout-btn" disabled>Checkout • <span id="mr-checkout-total">PKR 0</span></button>' +
          '<button id="mr-continue-btn">Continue Shopping</button>' +
        '</div>' +
      '</div>';

    document.body.appendChild(dr);
  }

  /* ===== FIX 1: Milestone HTML — last one shifted left ===== */
  function buildMilestonesHTML() {
    var enabled = CFG.milestones.filter(function(m){ return m.enabled; });
    if (!enabled.length) return '';
    var maxT = enabled[enabled.length - 1].threshold;

    return enabled.map(function(m, i){
      var isLast = (i === enabled.length - 1);
      /* all positions relative to max threshold */
      var pct = Math.round((m.threshold / maxT) * 100);
      var cls = 'mr-milestone' + (isLast ? ' mr-milestone-last' : '');
      return '<span class="' + cls + '" id="mr-ms-' + m.id + '" style="left:' + pct + '%">' +
        '<span class="mr-milestone-dot">' + (IC[m.icon] || IC.gift) + '</span>' +
        '<span class="mr-milestone-label">' + esc(m.label) + '</span>' +
      '</span>';
    }).join('');
  }

  /* ===== FETCH CART ===== */
  function fetchCart() {
    return fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function(r){ return r.json(); })
      .then(function(data){ cart = data; render(); return data; })
      .catch(function(e){ console.error('[MrCart] fetchCart:', e); });
  }

  /* ===== ADD ITEM — robust variant ID + error handling ===== */
  function addItem(variantId, qty, props, silent) {
    /* Accept string or number — Shopify needs integer */
    var vid = parseInt(String(variantId || '').replace(/[^0-9]/g, ''), 10);
    if (!vid || isNaN(vid) || vid <= 0) {
      console.warn('[MrCart] addItem skipped — invalid variantId:', variantId,
        '\nHint: Set freeGiftVariantId in mr-cart-config.js');
      return Promise.resolve();
    }
    setBusy(true);
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'X-MrCart-Origin': '1'   /* tag so patchFetch() ignores this call — prevents double-render */
      },
      body: JSON.stringify({ id: vid, quantity: qty || 1, properties: props || {} })
    })
    .then(function(r){
      if (!r.ok) return r.json().then(function(e){ throw new Error(e.description || 'Add failed'); });
      return r.json();
    })
    .then(function(){ return fetchCart(); })
    .then(function(c){
      if (c) checkMilestones(c);   /* ← was missing: without this, milestones/confetti
                                         never re-evaluate after our own addItem() calls
                                         (e.g. the free-gift auto-add itself) */
      if (!silent) openDrawer();
      setBusy(false);
      return c;
    })
    .catch(function(err){
      setBusy(false);
      console.error('[MrCart] addItem error:', err.message);
    });
  }

  /* ===== CHANGE QTY ===== */
  function changeQty(key, qty) {
    if (!key) return Promise.resolve();
    setBusy(true);
    return fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'X-MrCart-Origin': '1'
      },
      body: JSON.stringify({ id: key, quantity: qty })
    })
    .then(function(r){ return r.json(); })
    .then(function(c){ cart = c; checkMilestones(c); render(); setBusy(false); })
    .catch(function(e){ setBusy(false); console.error('[MrCart] changeQty:', e); });
  }

  /* ===== FREE GIFT — add/remove based on threshold ===== */
  /* ===== GIFT MANAGEMENT — auto-resolve variant ID from handle if needed ===== */

  /* Resolved variant ID cache */
  var resolvedGiftVid = null;

  function resolveGiftVariantId() {
    /* If already a number string, use directly */
    var raw = String(CFG.freeGiftVariantId || '').trim();
    if (!raw) return Promise.resolve(null);

    /* Already resolved and cached */
    if (resolvedGiftVid) return Promise.resolve(resolvedGiftVid);

    /* Numeric ID given directly */
    var num = parseInt(raw.replace(/[^0-9]/g, ''), 10);
    if (num > 0) {
      resolvedGiftVid = String(num);
      return Promise.resolve(resolvedGiftVid);
    }

    /* Handle given (e.g. 'free-gift-product') — fetch variant ID */
    return fetch('/products/' + raw + '.js', { credentials: 'same-origin' })
      .then(function(r){ return r.json(); })
      .then(function(p){
        if (p && p.variants && p.variants[0]) {
          resolvedGiftVid = String(p.variants[0].id);
          console.log('[MrCart] Gift variant resolved:', resolvedGiftVid, 'from handle:', raw);
          return resolvedGiftVid;
        }
        console.warn('[MrCart] Could not resolve gift variant from handle:', raw);
        return null;
      })
      .catch(function(e){
        console.warn('[MrCart] Gift handle fetch failed:', e.message);
        return null;
      });
  }

  function checkAndManageGift(c) {
    if (!CFG.freeGiftVariantId || String(CFG.freeGiftVariantId).trim() === '') {
      return Promise.resolve(false);
    }

    var giftMs = null;
    for (var i = 0; i < CFG.milestones.length; i++) {
      if (CFG.milestones[i].id === 'gift' && CFG.milestones[i].enabled) {
        giftMs = CFG.milestones[i]; break;
      }
    }
    if (!giftMs) return Promise.resolve(false);

    return resolveGiftVariantId().then(function(gid) {
      if (!gid) return false;

      /* Find gift item — match by variant_id OR by _mr_gift property */
      var nonGiftTotal = 0;
      var giftItem = null;
      for (var j = 0; j < c.items.length; j++) {
        var it = c.items[j];
        var isGift = String(it.variant_id) === gid ||
                     (it.properties && it.properties._mr_gift === 'yes');
        if (isGift) {
          giftItem = it;
        } else {
          nonGiftTotal += it.line_price;
        }
      }
      var totalRs = nonGiftTotal / 100;

      if (totalRs >= giftMs.threshold && !giftItem) {
        return addItem(gid, 1, { _mr_gift: 'yes' }, true).then(function(){ return true; });
      } else if (totalRs < giftMs.threshold && giftItem) {
        return changeQty(giftItem.key, 0).then(function(){ return true; });
      }
      return false; /* no change needed */
    });
  }

  /* ===== MILESTONE CHECKS =====
     checkMilestones() can be triggered from multiple places nearly
     simultaneously (a user's own add-to-cart AND the resulting gift
     auto-add both call it). If two calls run concurrently, the first
     one's gift-management step and the second one's read of `giftBusy`
     can interleave in a way that causes evaluateMilestones() to either
     run too early (gift not yet landed) or get silently skipped on the
     real final state — which is what caused confetti to be missed on
     the genuine gift-threshold crossing, and then fire incorrectly on
     every later add (because milestonesFired['gift'] was never set).

     Fix: every checkMilestones() call is queued and run strictly one
     at a time. No two gift-management/evaluate cycles ever overlap. */
  /* Only the LATEST cart snapshot matters — multiple checkMilestones(c)
     calls can arrive in quick succession (addItem, changeQty, cart:refresh,
     patchFetch all call it). If an older/stale snapshot got queued and
     was processed AFTER a newer one already marked a milestone as fired,
     evaluating that stale snapshot would see total < threshold and
     incorrectly delete the fired flag — causing confetti to refire on
     the next genuine update even though nothing was actually re-crossed.
     Keeping only the latest entry eliminates this entirely. */
  var latestCartSnapshot = null;
  var milestoneQueueRunning = false;

  function checkMilestones(c) {
    if (!c) return;
    latestCartSnapshot = c;
    runMilestoneQueue();
  }

  function runMilestoneQueue() {
    if (milestoneQueueRunning) return;
    if (!latestCartSnapshot) return;
    milestoneQueueRunning = true;

    var c = latestCartSnapshot;
    latestCartSnapshot = null;

    checkAndManageGift(c).then(function(cartChanged){
      if (!cartChanged) {
        evaluateMilestones(c);
      }
      /* If cartChanged is true, the gift add/remove already triggered
         its own fresh fetchCart() → checkMilestones(c) with the
         up-to-date cart — that call already updated latestCartSnapshot
         (or will), so the final state still gets evaluated next. */
      milestoneQueueRunning = false;
      runMilestoneQueue(); /* process the newest snapshot, if one arrived while busy */
    });
  }

  /* Confetti re-arms when total drops below a milestone's threshold —
     so if a customer removes an item and total goes back up past the
     same threshold later, confetti fires again. This is correct,
     expected behavior (reward for crossing the line each time it's
     genuinely crossed). What must NOT happen is firing more than once
     for a SINGLE genuine crossing — that was caused by duplicate
     fetch/render triggers elsewhere, not by this reset logic. */
  function evaluateMilestones(c) {
    var total = c.total_price / 100;
    var enabled = CFG.milestones.filter(function(m){ return m.enabled; });

    enabled.forEach(function(m){
      if (total >= m.threshold && !milestonesFired[m.id]) {
        milestonesFired[m.id] = true;
        if (prevTotalCents > 0) fireConfetti(2400);
      }
      if (total < m.threshold) delete milestonesFired[m.id];
    });

    prevTotalCents = c.total_price;
  }

  /* ===== RENDER ===== */
  function render() {
    if (!cart) return;
    var total = cart.total_price / 100;
    renderProgress(total);
    renderItems(cart.items);
    renderTotals(total);
    var ct = document.getElementById('mr-checkout-total');
    var cb = document.getElementById('mr-checkout-btn');
    if (ct) ct.textContent = fmt(total);
    if (cb) cb.disabled = cart.item_count === 0;
    var empty = document.getElementById('mr-empty');
    var wrap  = document.getElementById('mr-items-wrap');
    if (empty) empty.style.display = cart.item_count === 0 ? 'flex' : 'none';
    if (wrap)  wrap.style.display  = cart.item_count === 0 ? 'none'  : 'block';
  }

  /* ===== RENDER PROGRESS ===== */
  function renderProgress(total) {
    var enabled = CFG.milestones.filter(function(m){ return m.enabled; });
    if (!enabled.length) return;
    var maxT = enabled[enabled.length - 1].threshold;
    var pct  = Math.min((total / maxT) * 100, 100);

    /* Force red via inline style — belt AND suspenders */
    var fill = document.getElementById('mr-progress-fill');
    if (fill) {
      fill.style.cssText =
        'width:' + pct + '%;' +
        'height:10px;' +
        'background:#e74c3c;' +
        'background-color:#e74c3c;' +
        'border-radius:99px;' +
        'transition:width 0.55s ease;' +
        'position:relative;' +
        'z-index:1;' +
        'max-width:100%;' +
        'display:block;';
    }

    /* Milestone states */
    enabled.forEach(function(m){
      var el = document.getElementById('mr-ms-' + m.id);
      if (!el) return;
      if (total >= m.threshold) el.classList.add('mr-done');
      else el.classList.remove('mr-done');
    });

    /* Message */
    var msg = document.getElementById('mr-progress-msg');
    if (!msg) return;
    var next = null;
    for (var i = 0; i < enabled.length; i++) {
      if (total < enabled[i].threshold) { next = enabled[i]; break; }
    }
    var lastReached = null;
    for (var j = enabled.length - 1; j >= 0; j--) {
      if (total >= enabled[j].threshold) { lastReached = enabled[j]; break; }
    }

    if (!next) {
      msg.innerHTML = '🎁 Amazing! You\'ve unlocked all rewards!';
      msg.className = 'mr-unlocked';
    } else if (lastReached) {
      msg.innerHTML = '🎉 <strong>' + esc(lastReached.label) + '</strong> unlocked! ' +
        'Add <strong>' + fmt(next.threshold - total) + '</strong> more to get <strong>' + esc(next.label) + '</strong>';
      msg.className = 'mr-unlocked';
    } else {
      msg.innerHTML = 'Add <strong>' + fmt(next.threshold - total) + '</strong> more to get <strong>' + esc(next.label) + '</strong>';
      msg.className = '';
    }
  }

  /* ===== RENDER ITEMS ===== */
  function renderItems(items) {
    var wrap = document.getElementById('mr-items-wrap');
    if (!wrap) return;
    if (!items || !items.length) { wrap.innerHTML = ''; return; }

    wrap.innerHTML = items.map(function(item){
      var isGift = item.properties && item.properties._mr_gift === 'yes';
      var lp = item.line_price / 100;
      var op = item.original_line_price / 100;
      var hasDis = op > lp;
      var img = (item.featured_image && item.featured_image.url) || item.image || '';

      return '<div class="mr-item' + (isGift ? ' mr-is-gift' : '') + '" data-key="' + esc(item.key) + '">' +
        '<div class="mr-item-img">' +
          (img ? '<img src="' + esc(img) + '" alt="' + esc(item.product_title) + '" loading="lazy"/>' : '') +
        '</div>' +
        '<div class="mr-item-body">' +
          '<div class="mr-item-name">' + esc(item.product_title) + '</div>' +
          (item.variant_title && item.variant_title !== 'Default Title'
            ? '<div class="mr-item-variant">' + esc(item.variant_title) + '</div>' : '') +
          (isGift ? '<span class="mr-gift-badge">🎁 Free Gift</span>' : '') +
          '<div class="mr-item-bottom">' +
            (!isGift
              ? '<div class="mr-qty-ctrl">' +
                  '<button class="mr-qty-btn" data-key="' + esc(item.key) + '" data-delta="-1">−</button>' +
                  '<span class="mr-qty-num">' + item.quantity + '</span>' +
                  '<button class="mr-qty-btn" data-key="' + esc(item.key) + '" data-delta="1">+</button>' +
                '</div>' : '<span></span>') +
            '<div class="mr-item-price-wrap">' +
              (hasDis ? '<span class="mr-price-original">' + fmt(op) + '</span>' : '') +
              '<span class="mr-price-sale">' +
                (isGift ? '<span class="mr-green" style="font-weight:700">FREE</span>' : fmt(lp)) +
              '</span>' +
            '</div>' +
          '</div>' +
        '</div>' +
        (!isGift ? '<button class="mr-remove-btn" data-key="' + esc(item.key) + '">' + IC.trash + '</button>' : '') +
      '</div>';
    }).join('');
  }

  /* ===== RENDER TOTALS ===== */
  function renderTotals(total) {
    if (!cart) return;
    var sub  = cart.items_subtotal_price / 100;
    var disc = cart.total_discount / 100;

    var subEl = document.getElementById('mr-subtotal-val');
    var totEl = document.getElementById('mr-total-val');
    if (subEl) subEl.textContent = fmt(sub);
    if (totEl) totEl.textContent = fmt(total);

    var enabled = CFG.milestones.filter(function(m){ return m.enabled; });
    var shipMs = null;
    for (var i = 0; i < enabled.length; i++) {
      if (enabled[i].id === 'shipping') { shipMs = enabled[i]; break; }
    }
    var rs = document.getElementById('mr-row-shipping');
    if (rs) rs.style.display = (shipMs && total >= shipMs.threshold) ? '' : 'none';

    var rd = document.getElementById('mr-row-discount');
    var dv = document.getElementById('mr-discount-val');
    if (rd && dv) {
      rd.style.display = disc > 0 ? '' : 'none';
      if (disc > 0) dv.textContent = '− ' + fmt(disc);
    }
  }

  /* ===== OPEN / CLOSE ===== */
  function openDrawer() {
    isOpen = true;
    var ov = document.getElementById('mr-overlay');
    var dr = document.getElementById('mr-drawer');
    if (ov) ov.classList.add('mr-show');
    if (dr) dr.classList.add('mr-open');
    document.body.style.overflow = 'hidden';
    render();
  }

  function closeDrawer() {
    isOpen = false;
    var ov = document.getElementById('mr-overlay');
    var dr = document.getElementById('mr-drawer');
    if (ov) ov.classList.remove('mr-show');
    if (dr) dr.classList.remove('mr-open');
    document.body.style.overflow = '';
  }

  var isBusy = false;   /* track loading state — outside click blocked while busy */

  function setBusy(v) {
    isBusy = v;
    var d = document.getElementById('mr-drawer');
    if (d) { if (v) d.classList.add('mr-busy'); else d.classList.remove('mr-busy'); }
  }

  /* ===== FIX 4: CONFETTI — wider spread from bottom-right ===== */
  function fireConfetti(duration) {
    var canvas = document.getElementById('mr-confetti-canvas');
    if (!canvas) return;
    canvas.style.display = 'block';
    canvas.width  = window.innerWidth;
    canvas.height = window.innerHeight;
    var ctx = canvas.getContext('2d');
    /* Origin: bottom-right corner near checkout btn */
    var ox = canvas.width  - 50;
    var oy = canvas.height - 70;
    var colors = ['#e74c3c','#f39c12','#2ecc71','#3498db','#9b59b6','#e91e63','#ff9800','#00bcd4','#fff176'];
    var P = [];
    for (var i = 0; i < 200; i++) {
      /* Wide upward spread: angles from -250° to -30° (full left to right upward) */
      var ang = (Math.random() * 220 - 250) * Math.PI / 180;
      var spd = Math.random() * 12 + 3;
      P.push({
        x: ox, y: oy,
        vx: Math.cos(ang) * spd,
        vy: Math.sin(ang) * spd,
        w: Math.random() * 10 + 5,
        h: Math.random() * 5 + 3,
        color: colors[Math.floor(Math.random() * colors.length)],
        rot: Math.random() * 360,
        spin: (Math.random() - 0.5) * 10,
        grav: 0.18 + Math.random() * 0.12
      });
    }
    var t0 = null;
    function frame(ts) {
      if (!t0) t0 = ts;
      var el = ts - t0;
      var alpha = Math.max(0, 1 - el / duration);
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      P.forEach(function(p){
        p.x += p.vx; p.y += p.vy; p.vy += p.grav; p.rot += p.spin;
        ctx.save();
        ctx.globalAlpha = alpha;
        ctx.translate(p.x, p.y);
        ctx.rotate(p.rot * Math.PI / 180);
        ctx.fillStyle = p.color;
        ctx.fillRect(-p.w/2, -p.h/2, p.w, p.h);
        ctx.restore();
      });
      if (el < duration) requestAnimationFrame(frame);
      else { ctx.clearRect(0,0,canvas.width,canvas.height); canvas.style.display='none'; }
    }
    requestAnimationFrame(frame);
  }

  /* ===== SOCIAL PROOF ===== */
  /* ============================================================
     SOCIAL PROOF — IMPORTANT HONESTY NOTE

     If CFG.socialProofData contains hand-written fake names/times,
     every visitor sees the IDENTICAL sequence with the SAME
     "X minutes ago" label, every single visit. A repeat customer
     will eventually notice the exact same message at the exact
     same fake timestamp — this reads as fabricated activity and
     can damage trust rather than build it.

     This implementation fixes the worst offender (the frozen
     timestamp) by randomizing "mins ago" within a plausible
     window and shuffling order per session, so it's not
     IDENTICAL on every load. But this is a partial mitigation —
     the underlying entries are still not real orders.

     RECOMMENDED: replace CFG.socialProofData with real, anonymized
     recent-order data from your Shopify Orders API (e.g. via an
     app proxy endpoint that returns the last N orders with
     city + product, no PII). Until that's wired up, treat this
     popup as a placeholder — consider disabling it
     (socialProofEnabled: false) rather than shipping fake activity.
     ============================================================ */
  function startSocialProof() {
    if (!CFG.socialProofEnabled) return;   /* respects mr-cart-config.js toggle */
    if (!CFG.socialProofData || !CFG.socialProofData.length) return;

    /* Shuffle a copy once per page load — avoids identical sequence every visit */
    var pool = CFG.socialProofData.slice();
    for (var i = pool.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var tmp = pool[i]; pool[i] = pool[j]; pool[j] = tmp;
    }

    function show() {
      var d = pool[spIndex % pool.length]; spIndex++;
      var sp = document.getElementById('mr-social-proof'); if (!sp) return;
      var n = document.getElementById('mr-sp-name');
      var p = document.getElementById('mr-sp-product');
      var t = document.getElementById('mr-sp-time');
      var img = document.getElementById('mr-sp-img');

      /* Randomize "minutes ago" each display — avoids the exact frozen
         timestamp every visitor would otherwise see */
      var mins = (d.mins && d.mins > 0) ? d.mins : (Math.floor(Math.random() * 28) + 2);

      if (n) n.textContent = d.name + ' in ' + d.city + ', Pakistan purchased a';
      if (p) p.textContent = d.product;
      if (t) t.textContent = mins + ' minutes ago';
      if (img) {
        var u = (window.mrCartConfig && window.mrCartConfig.spImageUrl) || '';
        img.src = u; img.style.display = u ? '' : 'none';
      }
      sp.classList.add('mr-sp-show');
      setTimeout(function(){ sp.classList.remove('mr-sp-show'); }, 5000);
    }
    setTimeout(function(){ show(); setInterval(show, 18000); }, 8000);
  }

  /* ===== DISCOUNT ===== */
  function applyDiscount(code) {
    if (!code || !code.trim()) return;
    window._mrDiscCode = code.trim().toUpperCase();
    var msg = document.getElementById('mr-discount-msg');
    if (msg) { msg.textContent = '✓ Code saved! Applied at checkout.'; msg.className = ''; }
  }

  /* ===== FIX 5+6: EVENTS ===== */
  function bindEvents() {

    /* OVERLAY — direct bind (delegation misses it when pointer-events flicker) */
    var ovEl = document.getElementById('mr-overlay');
    if (ovEl) {
      ovEl.style.cursor = 'pointer';
      ovEl.addEventListener('click', function(e){
        e.stopPropagation();
        if (isBusy) return;   /* loading ke waqt overlay click bhi close na kare */
        closeDrawer();
      });
    }

    /* ALSO: click anywhere outside drawer while open = close
       BUT NOT while loading — isBusy check prevents accidental close during qty update */
    document.addEventListener('click', function(e){
      if (!isOpen) return;
      if (isBusy) return;   /* ← loading chal rahi ho to close mat karo */
      var dr = document.getElementById('mr-drawer');
      if (dr && !dr.contains(e.target) && e.target.id !== 'mr-overlay') {
        closeDrawer();
      }
    }, false);

    /* Close button */
    document.getElementById('mr-close-btn').addEventListener('click', closeDrawer);

    /* Continue shopping */
    document.getElementById('mr-continue-btn').addEventListener('click', closeDrawer);

    /* Checkout */
    document.getElementById('mr-checkout-btn').addEventListener('click', function(){
      var url = window._mrDiscCode
        ? '/checkout?discount=' + encodeURIComponent(window._mrDiscCode)
        : '/checkout';
      window.location.href = url;
    });

    /* Discount */
    var applyBtn = document.getElementById('mr-apply-btn');
    var discInp  = document.getElementById('mr-discount-input');
    if (applyBtn) applyBtn.addEventListener('click', function(){ if (discInp) applyDiscount(discInp.value); });
    if (discInp) discInp.addEventListener('keydown', function(e){ if (e.key === 'Enter') applyDiscount(this.value); });

    /* Social proof close */
    var spc = document.getElementById('mr-sp-close');
    if (spc) spc.addEventListener('click', function(){
      var sp = document.getElementById('mr-social-proof');
      if (sp) sp.classList.remove('mr-sp-show');
    });

    /* Delegated: qty + remove */
    document.addEventListener('click', function(e){
      var qb = e.target.closest && e.target.closest('.mr-qty-btn');
      if (qb && qb.dataset.key) {
        if (!cart) return;
        var key = qb.dataset.key;
        var delta = parseInt(qb.dataset.delta, 10);
        var found = null;
        for (var i = 0; i < cart.items.length; i++) {
          if (cart.items[i].key === key) { found = cart.items[i]; break; }
        }
        if (found) changeQty(key, Math.max(0, found.quantity + delta));
        return;
      }
      var rb = e.target.closest && e.target.closest('.mr-remove-btn');
      if (rb && rb.dataset.key) { changeQty(rb.dataset.key, 0); return; }
    });

    /* Intercept form submit */
    document.addEventListener('submit', function(e){
      var form = e.target;
      if (!form || !form.action || form.action.indexOf('/cart/add') === -1) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      handleFormAdd(form);
    }, true);

    /* FIX 5: Hijack Dawn's native cart icon — all possible selectors */
    hijackDawnCart();

    /* Dawn events */
    document.addEventListener('cart:add', function(e){
      if (e.detail && e.detail.variantId) addItem(e.detail.variantId, e.detail.quantity || 1);
    });
    document.addEventListener('cart:refresh', function(){
      fetchCart().then(function(c){ if (c) checkMilestones(c); });
    });

    patchFetch();
  }

  /* ===== FIX 5: HIJACK DAWN CART BUTTON ===== */
  function hijackDawnCart() {
    /* Run now + after DOM settles */
    attachCartBtnListeners();
    setTimeout(attachCartBtnListeners, 500);
    setTimeout(attachCartBtnListeners, 1500);
  }

  function attachCartBtnListeners() {
    var selectors = [
      'a[href="/cart"]',
      'button[data-cart-toggle]',
      '.cart-icon-bubble',
      'cart-notification-button',
      '[aria-label="Cart"]',
      '.header__icon--cart',
      '#cart-icon-bubble',
      'a.header__icon[href*="cart"]'
    ];
    selectors.forEach(function(sel){
      var els = document.querySelectorAll(sel);
      els.forEach(function(el){
        if (el.dataset.mrHijacked) return;  /* don't double-bind */
        el.dataset.mrHijacked = '1';
        el.addEventListener('click', function(e){
          e.preventDefault();
          e.stopImmediatePropagation();
          fetchCart().then(function(){ openDrawer(); });
        }, true);
      });
    });

    /* Also override Dawn's cart drawer/notification if it tries to open */
    if (window.Shopify && window.Shopify.theme) {
      /* Prevent Dawn's built-in cart notification from showing */
      var style = document.getElementById('mr-hide-dawn-cart');
      if (!style) {
        style = document.createElement('style');
        style.id = 'mr-hide-dawn-cart';
        style.textContent = 'cart-notification { display: none !important; } cart-drawer { display: none !important; }';
        document.head.appendChild(style);
      }
    }
  }

  function handleFormAdd(form) {
    var idInput = form.querySelector('[name="id"]');
    if (!idInput || !idInput.value) { openDrawer(); return; }

    /* Dawn uses a <quantity-input> web component — the actual <input>
       inside it has name="quantity" but form.querySelector may not find
       it correctly in all Dawn versions. We try multiple selectors to
       get the real displayed quantity value. */
    var qtyVal = 1;
    var qtySelectors = [
      'quantity-input input',           /* Dawn web component — primary */
      '[name="quantity"]',              /* standard form input */
      'input[id*="Quantity"]',          /* Dawn's id pattern: Quantity-template--... */
      '.quantity__input',               /* Dawn quantity CSS class */
      'input[type="number"]'            /* fallback: any number input in form */
    ];
    for (var si = 0; si < qtySelectors.length; si++) {
      var qEl = form.querySelector(qtySelectors[si]);
      if (qEl && qEl.value) {
        var parsed = parseInt(qEl.value, 10);
        if (parsed > 0) { qtyVal = parsed; break; }
      }
    }
    /* Also try outside the form — Dawn sometimes puts quantity-input
       as a sibling to the form, not nested inside it */
    if (qtyVal === 1) {
      var qOutside = document.querySelector('quantity-input input, .quantity__input, input[id*="Quantity"]');
      if (qOutside && qOutside.value) {
        var parsedOut = parseInt(qOutside.value, 10);
        if (parsedOut > 0) qtyVal = parsedOut;
      }
    }

    var props = {};
    form.querySelectorAll('[name^="properties"]').forEach(function(inp){
      var m = inp.name.match(/\[(.+)\]/);
      if (m) props[m[1]] = inp.value;
    });
    addItem(idInput.value, qtyVal, props);
  }

  /* Patch fetch — intercept Dawn/theme AJAX adds.
     IMPORTANT: skips any request tagged X-MrCart-Origin — those came
     from our own addItem()/changeQty(), which already handles its own
     fetchCart()+openDrawer() chain. Without this skip, every form-submit
     add-to-cart double-fires (our own call + this patched-fetch catch),
     causing duplicate cart fetches and a double drawer-render/flicker. */
  function patchFetch() {
    var orig = window.fetch;
    window.fetch = function(input, init){
      var url = typeof input === 'string' ? input : (input && input.url ? input.url : '');
      var isOurOwnCall = !!(init && init.headers && init.headers['X-MrCart-Origin']);
      var pr = orig.apply(this, arguments);

      if (isOurOwnCall) return pr;  /* ← prevents the double-fire */

      if (url && url.indexOf('/cart/add') !== -1 && init && init.method && init.method.toUpperCase() === 'POST') {
        pr.then(function(res){
          if (res && res.ok) {
            setTimeout(function(){
              fetchCart().then(function(c){
                if (c) { checkMilestones(c); openDrawer(); }
              });
            }, 150);
          }
        }).catch(function(){});
      }
      return pr;
    };
  }

  /* ===== UTILS ===== */
  function fmt(n) { return CFG.currency + ' ' + Math.round(n).toLocaleString('en-PK'); }
  function esc(s) {
    return String(s || '').replace(/[&<>"']/g, function(c){
      return({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'})[c];
    });
  }

  /* ===== INIT =====
     IMPORTANT: on page load, the cart may ALREADY be above one or more
     milestone thresholds (e.g. customer added items, then refreshed,
     or the gift was already auto-added in a previous session/render).
     Previously, milestonesFired stayed completely empty after init —
     only prevTotalCents was set. That meant the FIRST cart change after
     load would see "total >= threshold && !milestonesFired[id]" as true
     for any milestone the cart was already past, firing confetti for
     a crossing that didn't actually just happen. Worse: if that same
     milestone's threshold check kept evaluating against a cart that
     was always above it, but something downstream (e.g. a quantity
     change that also triggers the gift logic) caused milestonesFired
     to not persist correctly across the async queue, it could appear
     to "fire every time." Seeding milestonesFired here from the actual
     initial cart state fixes this at the source — already-passed
     milestones are marked fired BEFORE any confetti logic ever runs,
     so confetti only fires on a genuine new crossing going forward. */
  function init() {
    buildDOM();
    bindEvents();
    fetchCart().then(function(c){
      if (c) {
        prevTotalCents = c.total_price;
        var total = c.total_price / 100;
        CFG.milestones.forEach(function(m){
          if (m.enabled && total >= m.threshold) {
            milestonesFired[m.id] = true; /* already past this milestone on load — don't confetti for it */
          }
        });
      }
    });
    startSocialProof();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  window.mrCart = { open: openDrawer, close: closeDrawer, refresh: fetchCart };
})();
